import { SVG_ENUM } from "enums";
import { lazy, Suspense } from "react";

type P = {
  type: SVG_ENUM;
  className?: string;
};

const EyeSVG = lazy(() => import("assets/svg/EyeSVG"));
const CrossedEyeSVG = lazy(() => import("assets/svg/CrossedEyeSVG"));
const CloseCircleSVG = lazy(() => import("assets/svg/CloseCircleSVG"));
const LogoSVG = lazy(() => import("assets/svg/LogoSVG"));
const FilterSVG = lazy(() => import("assets/svg/FilterSVG"));
const PauseCircleSVG = lazy(() => import("assets/svg/PauseCircleSVG"));
const EPFailSVG = lazy(() => import("assets/svg/EPFailSVG"));
const EPSuccessSVG = lazy(() => import("assets/svg/EPSuccessSVG"));
const LogoWithoutTextSVG = lazy(() => import("assets/svg/LogoWithoutTextSVG"));
const PlayCircleSVG = lazy(() => import("assets/svg/PlayCircleSVG"));
const BackChevronSVG = lazy(() => import("assets/svg/BackChevronSVG"));

const SVG = ({ type, className = "" }: P) => {
  const getSvg = () => {
    switch (type) {
      case SVG_ENUM.LOGO:
        return <LogoSVG className={className} />;
      case SVG_ENUM.EYE:
        return <EyeSVG className={className} />;
      case SVG_ENUM.CROSSED_EYE:
        return <CrossedEyeSVG className={className} />;
      case SVG_ENUM.CLOSE_CIRCLE:
        return <CloseCircleSVG className={className} />;
      case SVG_ENUM.FILTER:
        return <FilterSVG className={className} />;
      case SVG_ENUM.PAUSE_CIRCLE:
        return <PauseCircleSVG className={className} />;
      case SVG_ENUM.EP_FAIL:
        return <EPFailSVG className={className} />;
      case SVG_ENUM.EP_SUCCESS:
        return <EPSuccessSVG className={className} />;
      case SVG_ENUM.LOGO_WITHOUT_TEXT:
        return <LogoWithoutTextSVG className={className} />;
      case SVG_ENUM.PLAY_CIRCLE:
        return <PlayCircleSVG className={className} />;
      case SVG_ENUM.BACK_CHEVRON:
        return <BackChevronSVG className={className} />;
      default:
        return null;
    }
  };

  return <Suspense fallback="">{getSvg()}</Suspense>;
};

export default SVG;
